/**
 * The keys holding an in-progress package selection.
 *
 * These are the only keys that should be dropped when a selection is abandoned
 * or completed. localStorage.clear() also removes token, jwt, userId, userType
 * and userStatus - which signs the person out mid-flow, so the next screen
 * renders with no session and the app appears to go blank.
 */
export const SELECTION_KEYS = [
  'selectedPackageId', 'selectedPackageName', 'selectedThemeId',
  'themeName', 'description',
];

export function clearPackageSelection() {
  SELECTION_KEYS.forEach((k) => localStorage.removeItem(k));
}

export default clearPackageSelection;
